import Footer from "../components/Footer"
import Home from "../components/Home"
import Navbar from "../components/Navbar"

const HomePage =()=>{
    return(
        <>
        {<Home/>}
        </>
    )
}
export default HomePage